/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue';
import VxCard from './components/vx-card/VxCard.vue';
import VxList from './components/vx-list/VxList.vue';
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue';
import FeatherIcon from './components/FeatherIcon.vue';
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue';
//Content builder components
import CenteredImageWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/CenteredImageWrapper';
import ResponsiveIframeWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/ResponsiveIframeWrapper';
import ResponsiveYoutubeWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/ResponsiveYoutubeWrapper';
import SaveButtons from '@/views/WorkExperiences/components/ActivitiesBlocks/SaveButtons';
import TextBlock from '@/views/WorkExperiences/components/ActivitiesBlocks/TextBlock';
import TextareaBlock from '@/views/WorkExperiences/components/ActivitiesBlocks/TextareaBlock';
import FileUploadButtonImmediate from '@/views/WorkExperiences/components/ActivitiesBlocks/FileUploadButtonImmediate';
import ButtonLinkWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/ButtonLinkWrapper';
import VideoTrigger from '@/components/UI/VideoTrigger';
import SwitchBlock from '@/views/WorkExperiences/components/ActivitiesBlocks/SwitchBlock';
import ResponsiveIframeYoutube from '@/components/UI/ResponsiveIframeYoutube';
import Heading from '@/components/Heading';

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);

//Content builder components
Vue.component('centered-image-wrapper', CenteredImageWrapper);
Vue.component('responsive-iframe-wrapper', ResponsiveIframeWrapper);
Vue.component('responsive-youtube-wrapper', ResponsiveYoutubeWrapper);
Vue.component('save-buttons', SaveButtons);
Vue.component('text-block', TextBlock);
Vue.component('textarea-block', TextareaBlock);
Vue.component('fileupload-button-immediate', FileUploadButtonImmediate);
Vue.component('button-link-wrapper', ButtonLinkWrapper);
Vue.component('video-trigger', VideoTrigger);
Vue.component('switch-block', SwitchBlock);
Vue.component('responsive-iframe-youtube', ResponsiveIframeYoutube);
Vue.component('heading', Heading);

// v-select component
import vSelect from 'vue-select';

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'XIcon',
          svgClasses: 'w-4 h-4 mt-1',
        },
      }),
  },
  OpenIndicator: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'ChevronDownIcon',
          svgClasses: 'w-5 h-5',
        },
      }),
  },
});

Vue.component(vSelect);
